import React from "react";
import {Typography} from "@mui/material";
import {InvestigatorOverviewPanel} from "../../components/internal-affairs/InvestigatorOverviewPanel";
import useUser from "../../hooks/useUser";
import {Navigate} from "react-router-dom";

export const InvestigatorOverviewPage = () => {
    const user = useUser()
    if (!user.isLoading && user.user && !user.hasPermissions(["internalAffairs:viewAllComplaints"])) {
        return <Navigate to="/" replace/>
    }
    return (
        <>
            <Typography variant="h5" fontWeight={600} gutterBottom>Investigator Overview</Typography>
            <InvestigatorOverviewPanel/>
        </>
    )
}
